export default function parallax( selector = '.js-parallax' , speed = 2, dir = false ) {
    const els = document.querySelectorAll( selector );

    els?.forEach( el => {
        const img = el.querySelector( "img" );

        (el as HTMLFormElement).style.overflow = "hidden";
        // img.style.scale = (1 + speed * 0.3).toString();
        img.style.scale = (1.1).toString();
    } )

    parallaxes()
    window.addEventListener( "load", parallaxes );
    window.addEventListener( "scroll", parallaxes );

    function parallaxes( ) {
        els?.forEach( el => {
            const img = el.querySelector( "img" );
            const elBox = el.getBoundingClientRect();
            const y = ((window.innerHeight / 2 - elBox.top) / window.innerHeight) * 80 * speed/2;

            dir = dir || el.hasAttribute( "data-par-reverse" );

            img.style.transform = `translateY(${dir ? -1 * y : y}px)`;
        } )
    }
}
